import React from 'react';
import './AddSectionModal.css';

const AddSectionModal = ({ children, open = false }) => {
  if (!open) {
    return null;
  }

  return <div className="add-section-modal-shell">{children}</div>;
};

export default AddSectionModal;
